import { Divider, Icon, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useState } from "react";
import emailBar from "../../assets/images/emailBar.webp";
import MockTooltipComponent from "./MockTooltipComponent";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../assets/css/mockEmailDetails.css'

const MockEmailDetails = ({ onCallBack }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const handleToast = () => {
    toast.success("Email Sent!", {
      icon: false,
      position: "top-center",
      autoClose: 1500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: 0,
    });
    setTimeout(() => {
      toast.info("You've received a new message \n From Jay Shetty Read Now", {
        icon: false,
        position: "top-center",
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
    }, 3000);
  }

  return (
    <div>
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={open}
        BackdropProps={{
          classes: {
            root: classes.backDrop,
          },
        }}
      >
        <div className={classes.modalRoot}>
          <div className={classes.divStyle}>
            <Typography className={classes.composeEmailStyle}>
              Compose an Email
            </Typography>
            <Icon
              baseClassName="fas"
              className="fa solid fa-xmark"
              style={{
                fontSize: "16px",
                color: "#000000",
                marginTop: "12px",
                opacity: 0.75,
              }}
            />
          </div>
          <Divider className={classes.borderLine} />
          <div className={classes.divSpecStyle}>
            <Typography className={classes.emailTitleStyle}>To:</Typography>
            <Typography className={classes.emailBodyStyle}>
              Jay Shetty
            </Typography>
          </div>
          <Divider className={classes.specBorderLine} />
          <div className={classes.divSpecStyle}>
            <Typography className={classes.emailTitleStyle}>CC:</Typography>
            <Typography className={classes.emailBodyStyle}>
              Pelpola Vijaya, Caroll Doyle
            </Typography>
          </div>
          <Divider className={classes.specBorderLine} />
          <div className={classes.divSpecStyle}>
            <Typography className={classes.emailTitleStyle}>Subject</Typography>
            <Typography className={classes.emailBodyStyle}>
              Update Requested
            </Typography>
          </div>
          <Divider className={classes.specBorderLine} />
          <div style={{ display: "block" }}>
            <Typography className={classes.emailContentStyle}>
              Dear Jay,
            </Typography>
            <Typography className={classes.emailContentStyle}>
              We need an urgent update for PO # 12087633979. Please provide us
              an update of the expected delivery date ASAP.
            </Typography>
            <Typography className={classes.emailContentStyle}>
              Jones Ferdinand
            </Typography>
            <p style={{ margin: 0, marginBottom: "40px" }}>
              Procurement Mananager
            </p>
          </div>
          <Divider className={classes.addressBorderLine} />
          <p style={{ margin: 0, fontWeight: "bold" }}>Jones Ferdinand</p>
          <p style={{ margin: 0 }}>Procurement Mananager</p>
          <p style={{ margin: 0, marginBottom: "32px" }}>(+94)(011)2449834</p>
          <div style={{ display: "inline-flex" }}>
            <MockTooltipComponent
              placement="left-end"
              open={open}
              popper
              title={
                <>
                  <Typography className={classes.tooltipTitleStyle}>
                  Press Send Email
                  </Typography>
                  <p className={classes.tooltipTextStyle}>
                    Use one of our template messsages, or write your own.
                    <span className={classes.newLine}>
                      Press{" "}
                      <b>Send Email</b> to continue.
                    </span>
                  </p>
                  <Typography className={classes.stepTextStyle}>
                    (10/19)
                  </Typography>
                </>
              }
              child={
                <div
                  style={{
                    width: "104px",
                    padding: "8px",
                    backgroundColor: "#000000",
                    color: "#ffffff",
                    fontWeight: 600,
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                  onClick={() => {
                    onCallBack();
                    setOpen(false);
                  }}
                >
                  <span onClick={handleToast}>Send Email</span>
                </div>
              }
            />
            <img
              src={emailBar}
              style={{ marginLeft: "40px", width: "180px", marginTop: "0%" }}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default MockEmailDetails;

const useStyles = makeStyles((theme) => ({
  modalRoot: {
    width: "516px",
    height: "auto",
    padding: "16px",
  },
  composeEmailStyle: {
    fontSize: "24px",
    fontFamily: "Inter",
    fontWeight: "700",
    width: "464px",
  },
  borderLine: {
    width: "516px",
    marginLeft: "-16px",
    marginTop: "16px",
  },
  emailTitleStyle: {
    fontSize: "14px",
    fontFamily: "Inter",
    fontWeight: "700",
    width: "64px",
  },
  emailBodyStyle: {
    marginLeft: "32px",
    fontSize: "14px",
    fontFamily: "Inter",
    fontWeight: "400",
  },
  divStyle: {
    width: "500px",
    display: "flex",
  },
  divSpecStyle: {
    paddingTop: "16px",
    width: "500px",
    display: "flex",
  },
  specBorderLine: {
    width: "516px",
    marginLeft: "-16px",
    marginTop: "16px",
  },
  emailContentStyle: {
    fontSize: "14px",
    fontFamily: "Inter",
    fontWeight: "400",
    marginTop: "16px",
  },
  addressBorderLine: {
    width: "200px",
    marginTop: "16px",
  },
  tooltipTextStyle: {
    marginTop: "0px",
    fontSize: "14px",
    fontFamily: "Inter",
    lineHeight: "20px",
    fontWeight: 400,
  },
  tooltipTitleStyle: {
    marginTop: "0px",
    fontSize: "20px",
    fontFamily: "Inter",
    fontWeight: 600,
    marginBottom: '8px'
  },
  stepTextStyle: {
    padding: "0px",
    margin: "0px",
    fontSize: "14px",
    textAlign: "end",
    marginTop: "-10px",
    marginBottom: "-10px",
  },
  newLine: {
    display: "block",
    marginTop: "15px"
  }
}));
